import { T } from '../../../utils/I18n/I18n'
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CheckoutPlaceOrderButton from '../CheckoutPlaceOrderButton/CheckoutPlaceOrderButton';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';

const PlaceOrderWithTerms = ({ isOrderCreating }) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [subscriptionChecked, setSubscription] = useState(false);
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
  return (
    <div className="payment-methods">
      <div className="checkout__main__form__checkbox">
        <label className="termsText" htmlFor="accept-terms">
          <input
            id="terms"
            name="accept-terms"
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />

          <Link to="#" onClick={() => setIsTermsOpen(true)}>
            <T id="cartSummary.acceptUserTerms" />
            <span className="required">*</span>
          </Link>
        </label>

        {isTermsOpen && <TermsAndConditions setIsTermsOpen={setIsTermsOpen} />}
      </div>
      <div className="checkout__main__form__checkbox">
        <label htmlFor="newsletter">
          <input type="checkbox" id="newsletter" onChange={() => setSubscription(prevState => !prevState)} />
          <T id="cartSummary.applyForNewsletter" />
        </label>
      </div>

      <CheckoutPlaceOrderButton isOrderCreating={isOrderCreating} isChecked={isChecked} subscriptionChecked={subscriptionChecked} />
    </div>
  );
};

export default PlaceOrderWithTerms;
